export const common = {
  "common.beta": "Beta",
  "common.preparing-results": "Analyzing your decisions...",
};
